/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { useCallback, useMemo, useRef, useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  disableWifi,
  enableWifi,
  getWifiStatus as getWifiStatusCall,
} from '../../../../../../actions/EpikBoxes';
import {
  AP_SECURITY_OPTIONS,
  CLIENT_SECURITY_OPTIONS,
  MODE,
  MODE_DROP_DOWN_OPTIONS,
  CLIENT_MODE_SELECTED,
  AP_MODE_SELECTED,
  STATUS,
  UNKNOWN_ERROR,
  INVALID_VPN,
  SEC_NONE,
  WIFI_STATUS_SUCCESS,
  ENABLE_WIFI_SUCCESS,
  DISABLE_WIFI_SUCCESS,
  DEFAULT_MODE_DROP_DOWN_OPTION,
  DEFAULT_SEC_DROP_DOWN_OPTION,
  DROP_DOWN_TYPE,
} from '../constants';
import addBoxAction from '../../../../../../lib/api/addBoxAction';
import addNote from '../../../../../../lib/api/addNote';
// import {
//   enableWifiMockResponse,
//   enableWifiErrorResponse,
//   checkWifiStatusResponse,
//   disableWifiMockResponseForAlreadyEnabledBox,
//   checkWifiMockResponseForCheckingDisableResponse,
// } from '../helper';

const useEpikboxNetworking = (box, token_) => {
  const dispatch = useDispatch();
  const lockedState = useSelector(state => state.UIState.epikBoxes.lockStatusEpikBox);

  const [modeDropDown, _] = useState(MODE_DROP_DOWN_OPTIONS);
  const [mode, setMode] = useState(DEFAULT_MODE_DROP_DOWN_OPTION);

  const [secDropDown, setSecDropDown] = useState(CLIENT_SECURITY_OPTIONS);
  const [sec, setSec] = useState(DEFAULT_SEC_DROP_DOWN_OPTION);

  const [showWifiSection, setShowWifiSection] = useState(false);

  const [wifiStatus, setWifiStatus] = useState({
    Password: '',
    Mode: mode.value,
    Sec_Mode: sec.value,
    SSID: '',
  });

  const [loading, setLoading] = useState(false);

  const token = useRef(token_);

  const vpnAddress = useMemo(() => {
    if (!box.vpnAddress) return '0.0.0.0';
    /* UNCOMMENT FOR TESTING */
    // return '10.15.56.126';
    return box.vpnAddress;
  }, [box.vpnAddress]);

  const validateVpnAddress = useCallback(() => {
    const vpnArray = vpnAddress.split('.').map(Number);
    if (vpnArray[0] !== 10 || (vpnArray[1] !== 15 && vpnArray[1] !== 64) || vpnArray[2] < 20) {
      toast.error(INVALID_VPN);
      return false;
    }
    return true;
  }, [vpnAddress]);

  const getSecLabelBasedOnMode = useCallback((Mode, Sec_Mode) => {
    let label = 'None';
    let value = 'None';

    if (Sec_Mode === 'WPA/TKIP') {
      label = 'WPA-PSK [TKIP] + WPA2-PSK [AES]';
      value = Mode === MODE.CLIENT ? 'WPA' : 'WPA/TKIP';
    }
    if (Sec_Mode === 'WPA') {
      label = 'WPA2-PSK [AES]';
      value = 'WPA';
    }
    if (Sec_Mode === 'None') {
      label = 'None';
      value = 'None';
    }

    return { label, value };
  }, []);

  const changeRequiredStates = useCallback((Mode, Sec_Mode) => {
    switch (Mode) {
      case MODE.CLIENT: {
        setSecDropDown(CLIENT_SECURITY_OPTIONS);
        setMode(CLIENT_MODE_SELECTED);
        setSec(getSecLabelBasedOnMode(Mode, Sec_Mode));
        break;
      }
      case MODE.AP: {
        setSecDropDown(AP_SECURITY_OPTIONS);
        setMode(AP_MODE_SELECTED);
        setSec(getSecLabelBasedOnMode(Mode, Sec_Mode));
        break;
      }
      default:
        break;
    }
  }, []);

  const setDraftForDisableAction = useCallback(draft => {
    setWifiStatus(draft);
    setLoading(false);
    setShowWifiSection(true);
    setMode(DEFAULT_MODE_DROP_DOWN_OPTION);
    setSec(DEFAULT_SEC_DROP_DOWN_OPTION);
  }, []);

  const setDraftForEnableWifiCheckStatusAction = useCallback(
    res => {
      res.Status === STATUS.DISABLED
        ? setWifiStatus({ ...res, Mode: wifiStatus.Mode, Sec_Mode: wifiStatus.Sec_Mode })
        : setWifiStatus(res);
      setLoading(false);
      setShowWifiSection(true);
    },
    [wifiStatus],
  );

  const callDisableWifi = useCallback(async () => {
    setLoading(true);
    try {
      const res = await dispatch(disableWifi(token?.current, vpnAddress));
      // const res = await disableWifiMockResponseForAlreadyEnabledBox();
      if (!res) {
        setLoading(false);
        return null;
      }

      if (res?.Error_Msg && !res?.Status) {
        toast.error(res.Error_Msg);
        setLoading(false);
        setShowWifiSection(false);
        return null;
      }

      const draft = {
        ...wifiStatus,
        ...res,
        Mode: DEFAULT_MODE_DROP_DOWN_OPTION.value,
        Sec_Mode: DEFAULT_SEC_DROP_DOWN_OPTION.value,
      };

      console.info("DRAFT => ", draft);
      setDraftForDisableAction(draft);

      res?.Error_Msg ? toast.error(res.Error_Msg) : toast.success(DISABLE_WIFI_SUCCESS);
    } catch (error) {
      toast.error(UNKNOWN_ERROR);
    }
  }, [token?.current, vpnAddress, wifiStatus]);

  const callEnableWifi = useCallback(async () => {
    const { Mode, Sec_Mode, SSID, Password } = wifiStatus;
    const draft = {
      mode: Mode,
      sec: Sec_Mode,
      ssid: SSID,
      pswd: Password,
    };
    console.info('ENABLE WIFI', draft);
    try {
      setLoading(true);

      const res = await dispatch(enableWifi(token?.current, vpnAddress, draft));
      // const res = await enableWifiErrorResponse();
      if (!res) {
        setLoading(false);
        return null;
      }

      if (res?.Error_Msg && !res?.Status) {
        toast.error(res.Error_Msg);
        setLoading(false);
        setShowWifiSection(false);
        return null;
      }

      const { Mode: Mode_, Sec_Mode_ } = res;
      changeRequiredStates(Mode_, Sec_Mode_);

      setDraftForEnableWifiCheckStatusAction(res);

      res?.Error_Msg ? toast.error(res.Error_Msg) : toast.success(ENABLE_WIFI_SUCCESS);
    } catch (error) {
      toast.error(UNKNOWN_ERROR);
    }
  }, [vpnAddress, wifiStatus, token?.current]);

  const handleConnectDisconnect = useCallback(
    async e => {
      e.preventDefault();
      if (!wifiStatus?.Status) return;

      const { Status } = wifiStatus;

      switch (Status) {
        case STATUS.ENABLED: {
          await callDisableWifi();
          addBoxAction({ boxID: box?._id, activity: 'disconnected Wifi' });
          addNote({ boxID: box?._id, note: "Wifi disconnected"});
          break;
        }
        case STATUS.DISABLED: {
          await callEnableWifi();
          addBoxAction({ boxID: box?._id, activity: 'connected Wifi' });
          addNote({ boxID: box?._id, note: "Wifi connected"});
          break;
        }
        default:
          break;
      }
    },
    [wifiStatus],
  );

  const getWifiStatus = useCallback(async () => {
    if (!validateVpnAddress(vpnAddress)) {
      setShowWifiSection(false);
      return;
    }
    setLoading(true);
    try {
      const res = await dispatch(getWifiStatusCall(token?.current, vpnAddress));
      // const res = await checkWifiMockResponseForCheckingDisableResponse();
      // const res = await checkWifiStatusResponse();
      if (!res) {
        setLoading(false);
        setShowWifiSection(false);
        return null;
      }

      if (res?.Error_Msg && !res?.Status) {
        // toast.error(res.Error_Msg);
        setLoading(false);
        setShowWifiSection(false);
        return null;
      }

      if (res && typeof res === 'object') {
        const { Mode, Sec_Mode } = res;

        changeRequiredStates(Mode, Sec_Mode);

        setDraftForEnableWifiCheckStatusAction(res);

        res?.Error_Msg ? toast.error(res.Error_Msg) : toast.success(WIFI_STATUS_SUCCESS);
      }
    } catch (error) {
      toast.error(UNKNOWN_ERROR);
    }
  }, [vpnAddress, token?.current]);
  // }, [vpnAddress,]);

  // useLayoutEffect(() => {
  //   console.log('lockedState',lockedState)
  //   getWifiStatus();
  // }, [lockedState]);
  // useEffect(() => {
  //   getWifiStatus();
  // }, [lockedState.locked]);
  console.log('box',box);
  useEffect(() => {
    const checkThirdOctet = parseInt(box?.vpnAddress?.split('.')[2], 10) >= 20;
    const cleanedModel = box?.model?.replace(/^"|"$/g, ''); // Remove leading and trailing double quotes
    const isModelG44100 = cleanedModel === 'G4-4100';
    if (checkThirdOctet !== null && checkThirdOctet && !isModelG44100) {
      getWifiStatus();
    }
  }, [lockedState.locked, box]);

  const handleDropDowns = useCallback(
    value => {
      switch (value) {
        case MODE.CLIENT: {
          setSecDropDown(CLIENT_SECURITY_OPTIONS);
          break;
        }
        case MODE.AP: {
          setSecDropDown(AP_SECURITY_OPTIONS);
          break;
        }
        default:
          break;
      }
    },
    [wifiStatus],
  );

  const handleDropDownChange = useCallback(
    (e, type) => {
      const { value } = e;
      switch (type) {
        case DROP_DOWN_TYPE.SEC_MODE: {
          setSec({ label: `${value}`, value: `${value}` });
          break;
        }
        case DROP_DOWN_TYPE.MODE: {
          setMode({ label: `${value}`, value: `${value}` });
          handleDropDowns(value);
          break;
        }
        default:
          break;
      }
      value === SEC_NONE
        ? setWifiStatus({ ...wifiStatus, Password: '', [type]: value })
        : setWifiStatus({ ...wifiStatus, [type]: value });
    },
    [wifiStatus],
  );

  useEffect(() => () => setShowWifiSection(false), []);

  useEffect(() => {
    console.info('WIFI STATUS STATE => ', wifiStatus);
  }, [wifiStatus]);
  return {
    mode,
    sec,
    loading,
    modeDropDown,
    secDropDown,
    wifiStatus,
    showWifiSection,
    handleDropDownChange,
    setWifiStatus,
    handleConnectDisconnect,
  };
};

export default useEpikboxNetworking;
